import { createRouter, createWebHistory } from 'vue-router'
import ChatView from './views/ChatView.vue'
import LoginView from './views/LoginView.vue'
import RegisterView from './views/RegisterView.vue'
import { pb } from './services/pocketbase'
import PrintView from './views/PrintView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', redirect: '/chat' },
    { path: '/login', name: 'login', component: LoginView, meta: { public: true } },
    {
      path: '/register',
      name: 'register',
      component: RegisterView,
      meta: { public: true },
    },
    { path: '/chat/:conversationId?', name: 'chat', component: ChatView },
    { path: '/print/:conversationId', name: 'print', component: PrintView },
  ],
})

router.beforeEach((to) => {
  if (!to.meta.public && !pb.authStore.isValid) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }
  if (to.meta.public && pb.authStore.isValid) {
    return { name: 'chat' }
  }
  return true
})

export default router

